export { default } from "./NewUserInfoPage";
